import { Store, type SqlDriver } from '@nexus/store';
import { createWorkerDriver } from '@nexus/store/wasm-client';
import { createTauriDriver, isTauri } from '@nexus/store/tauri';
import SqliteWorker from './sqlite.worker?worker';

export interface OpenedStore {
  store: Store;
  /** For backups (the browser exports through it). */
  driver: SqlDriver;
  backend: 'desktop' | 'browser';
  persistent: boolean;
  reason?: string;
}

export async function openStore(): Promise<OpenedStore> {
  let driver: SqlDriver & { reason?: string };
  let backend: OpenedStore['backend'];
  if (isTauri()) {
    driver = await createTauriDriver();
    backend = 'desktop';
  } else {
    driver = await createWorkerDriver(new SqliteWorker());
    backend = 'browser';
    // Ask the browser not to evict our data under storage pressure. Not awaited:
    // Firefox shows a permission prompt and the promise stays pending until answered.
    void navigator.storage?.persist?.().catch(() => false);
  }
  const store = await Store.open(driver);
  return {
    store,
    driver,
    backend,
    persistent: driver.persistent,
    ...(driver.reason ? { reason: driver.reason } : {}),
  };
}
